namespace advisorop.components.advisor {

    export class DmsListController {
        // bindings
        accountId: number;
        accountNumber: string;
        investor: domains.IInvestor;
        documentTypes: domains.ILOV[] = [];
        selDocumentType: domains.ILOV;
        documents: any[];
        documentCountChanged: any;
        isCustodianAccount: boolean;

        dgDocumentsOptions: DevExpress.ui.dxDataGridOptions;
        dgDocuments: DevExpress.ui.dxDataGrid;
        dxUploadToCustodianCheckboxOptions: DevExpress.ui.dxCheckBoxOptions;

        // uploadDisabled: true;

        showDisabled: boolean = false;
        includeHistory: boolean = false;

        documentDate: Date = new Date();

        sendingCustodianLadda: boolean = false;
        enableUploadSelectedFilesToCustodian: boolean = false;
        sendMultipleFilesConfirmed: boolean = false;

        showUploadToCustodianButton: boolean = false;

        puAttachDocumentOptions: DevExpress.ui.dxPopupOptions;
        showAttachDocument: boolean = false;
        attachDocumentTitle: string;
        attachDocumentId: number;
        attachVersionNumber: number;

        iAmReady: any;

        static $inject = ["advisorService", "generalService"];
        constructor(
            private advisorService: advisorop.services.AdvisorService,
            private generalService: advisorop.services.GeneralService
        ) {
            this.puAttachDocumentOptions = {
                deferRendering: false,
                width: 600,
                height: 400,
                contentTemplate: "attachPopup",
                showTitle: true,
                dragEnabled: false,
                closeOnOutsideClick: false,
                bindingOptions: {
                    visible: "vm.showAttachDocument",
                    title: "vm.attachDocumentTitle"
                },
                toolbarItems: [
                    {
                        widget: "dxButton",
                        location: "center",
                        toolbar: "bottom",
                        options: {
                            text: "Close",
                            onClick: () => {
                                this.closeAttach();
                            }
                        }
                    }
                ]
            };

            this.dgDocumentsOptions = {
                export: {
                    enabled: true,
                    fileName: "Documents"
                },
                bindingOptions: {
                    dataSource: "vm.documents"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: false,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                noDataText: "No Documents",
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { caption: "Send to Custodian", dataType: "boolean", cellTemplate: "uploadToCustodian", visible: this.showUploadToCustodianButton },
                    { dataField: "documentTypeDesc", caption: "Document Type", width: 225 },
                    { dataField: "dateCreated", caption: "Date Uploaded", dataType: "date", width: 100 },
                    { dataField: "documentDate", caption: "Document Date", dataType: "date", width: 100 },
                    { dataField: "version", caption: "Ver.", width: 40 },
                    { dataField: "extension", caption: "Ext.", width: 40 },
                    { dataField: "uploadedToCustodian", caption: "Uploaded to Custodian", dataType: "date", visible: this.showUploadToCustodianButton },
                    { dataField: 'enableDisableStatus', caption: 'File Status', width: 70 },
                    { dataField: "id", caption: "Actions", cellTemplate: "colActions", alignment: "left" }
                ],
                masterDetail: {
                    enabled: true,
                    template: "versions",
                    autoExpandAll: false
                },
                onInitialized: e => {
                    this.dgDocuments = e.component;
                    this.showUploadToCustodianBtn();
                }
            };

            this.dxUploadToCustodianCheckboxOptions = {
                bindingOptions: {
                    disabled: "doc.data.enableDisableStatus=='Disabled'||doc.data.uploadedToCustodian||!doc.data.signedDocumentType",
                    value: "doc.data.sendToCustodian"
                },
                onValueChanged: e => {
                    this.uploadToCustodianSelectionChanged();
                }
            };

        }

        uploadToCustodianSelectionChanged() {
            this.enableUploadSelectedFilesToCustodian = this.documents.filter(d => { return d.sendToCustodian }).length > 0;
        }

        uploadedDocuments(object: Object) {
            //console.log("upload completed...");
            this.loadDocuments();
            toastr.success("Document(s) has been successfully uploaded");
        }

        disableDocument(docId: number, docVersion: number) {
            if (window.confirm("This action will disable the document within the system. Are you sure about this?")) {
                this.advisorService.disableDocument(docId, docVersion).then(
                    response => { this.loadDocuments(); toastr.success("Document has been successfully disabled"); },
                    err => this.generalService.showError(err)
                );
            }
        };

        enableDocument(docId: number, docVersion: number) {
            this.advisorService.enableDocument(docId, docVersion).then(
                response => { this.loadDocuments(); toastr.success("Document has been successfully enabled"); },
                err => this.generalService.showError(err)
            );
        };

        uploadSelectedFilesToCustodian() {
            this.sendingCustodianLadda = true;

            let files = this.documents.filter(d => d.sendToCustodian);

            let filenames = files.reduce((names, currentFile, index) => {
                let typeAndVersion = currentFile.documentTypeDesc + "(" + currentFile.version + ")";
                return index == 0 ? typeAndVersion : names + "\n" + typeAndVersion; 
                    }, "");

            if (window.confirm(`You are about to upload the following documents to the custodian.\n${filenames}\nAre you sure?`)) {
                this.sendMultipleFilesConfirmed = true;
                for (var doc of files) {
                    this.uploadToCustodian(doc, doc.id, doc.version);
                }
            } 
            this.sendMultipleFilesConfirmed = false;
            this.sendingCustodianLadda = false;
        }

        uploadToCustodian(docObjectData: any, docId: number, docVersion: number) {

            docObjectData.ladda = true;

            if (this.sendMultipleFilesConfirmed || window.confirm("You are about to upload this document to the custodian. Are you sure?")) {
                this.advisorService.uploadDocumentToCustodian(this.accountId, docId, docVersion).then(
                    response => { toastr.success("Document has been successfully uploaded"); },
                    err => this.generalService.showError(err)
                ).finally(() => {
                    docObjectData.ladda = false;
                });
            } else {
                docObjectData.ladda = false;
            }
        };


        // loading methods
        refresh(): void {
            this.loadDocuments();
        }

        loadDocuments(): void {
            //console.log("Loading documents .... Account:", this.accountId, " Investor:", this.investor);
            if (this.accountId > 0) {
                this.advisorService.getAccountDocumentation(this.accountId, this.includeHistory, this.showDisabled)
                    .then(response => {
                        this.documents = response.data;
                        if (this.documentCountChanged != undefined)
                            this.documentCountChanged({ count: this.documents.length });
                        if (this.documents.length > 0)
                            this.documents.sort((a, b) => a.documentTypeDesc < b.documentTypeDesc ? -1 : a.documentTypeDesc > b.documentTypeDesc ? 1 : 0)
                    }, err => this.generalService.showError(err));
            } else if (this.investor && this.investor.id > 0) {
                this.advisorService.getInvestorDocumentation(this.investor.id, this.includeHistory, this.showDisabled)
                    .then(response => this.documents = response.data, err => this.generalService.showError(err));
            }
            //console.log("Documents:", this.documents);
        }

        updateCustodianColumns(): void {
            if (this.dgDocuments != undefined) {
                this.dgDocuments.columnOption("uploadedToCustodian", "visible", this.showUploadToCustodianButton);
                this.dgDocuments.columnOption("Send to Custodian", "visible", this.showUploadToCustodianButton);
            } else {
                //console.log("Should not hit this.");
            }
        }

        showUploadToCustodianBtn(): void {
            if (this.dgDocuments != undefined) {
                if (this.isCustodianAccount == undefined) {
                    if (this.accountId > 0) {
                        this.advisorService.getAccountType(this.accountId).
                            then(data => {
                                this.showUploadToCustodianButton = (data.data == domains.InvestmentType.CUSTODIAN_ACCOUNT);
                                //console.log("this.showUploadToCustodianButton: ", this.showUploadToCustodianButton);
                                this.updateCustodianColumns();
                            });
                    }
                } else {
                    this.showUploadToCustodianButton = this.isCustodianAccount;
                    this.updateCustodianColumns();
                }
            }
        }

        attachPopup(docObjectData: any, level: number) {
            //console.log("DOC OBJECT DATA", docObjectData);
            if (level == 1)
                this.attachDocumentId = docObjectData.id;
            else
                this.attachDocumentId = docObjectData.documentId;
            this.attachVersionNumber = docObjectData.version;
            this.attachDocumentTitle = "Add attachment to " + docObjectData.documentTypeDesc + " document";
            this.showAttachDocument = true;
        };

        closeAttach() {
            this.showAttachDocument = false;
            this.loadDocuments();
        }

        // overrides
        $onChanges(evt): void {
            //console.log("Here we are getting changes.")
            if (!evt.accountId.isFirstChange() || !evt.investor.isFirstChange()) {
                this.loadDocuments();
            } else {
                // documents will be loaded in $onInit
                //console.log("FirstTime");
            }

            if (!evt.isCustodianAccount.isFirstChange()) {
                this.showUploadToCustodianBtn();
            } else {
                // custodian test will be done in $onInit
                //console.log("FirstTime");
            }
        }

        $onInit(): void {
            //console.log("$onInit()");
            this.loadDocuments();
            this.showUploadToCustodianBtn();
            if (this.iAmReady) {
                this.iAmReady({ ctrl: this });
            }
        }

    }

    class DmsList implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                accountId: "<",
                accountNumber: "<",
                investor: "<",
                isCustodianAccount: "<",
                documentCountChanged: "&",
                iAmReady: "&"
            };
            this.controller = DmsListController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/dms-list.html";
        }

    }
    angular.module(Constants.APP).component("dmsList", new DmsList());
}